<template>
    <v-container fluid class="pa-0">
        <!--get info-->
        <v-container class="my-4">
            <v-form v-model="valid" ref="form" validation>
                <v-row>
                    <v-col cols="12" sm="4" md="2">
                        <v-select dense color="secondary" item-color="secondary" 
                            v-model="game" 
                            :items="games"
                            item-text="id"
                            item-value="id"
                            label="game id" 
                            :rules="[rules.required]">
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="2">
                        <v-text-field dense
                            color="secondary"
                            v-model="round"
                            label="current round"
                            readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="2" class="mt-4">
                        <v-btn color="secondary" small dark class="text-lowercase" 
                            :disabled="!valid || Boolean(error)"
                            @click="load">load
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="3" md="2" class="mt-4">
                        <v-btn color="secondary" small dark class="text-lowercase" 
                            :disabled="!valid || Boolean(error)"
                            @click="calculate">
                            calculate
                        </v-btn>
                    </v-col>
                    <v-col v-if="financesRout"
                        cols="12" sm="3" md="2" class="mt-4">
                        <v-btn color="secondary" small dark class="text-lowercase" 
                            :disabled="!valid || Boolean(error)"
                            @click="transitionNext">
                            next round transition
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
        <!--tabs-->
        <v-divider></v-divider>
        <v-tabs v-model="tab" height="55" background-color="primary" fixed-tabs hide-slider dark>
            <v-tab :to="item.link" ripple class="text-capitalize" 
                exact-active-class v-for="(item, i) in itemsTab" :key="i">
                {{ item.title }}
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="/admin/summary/franchise">
                <franchise></franchise>
            </v-tab-item>
            <v-tab-item value="/admin/summary/peakSize">
                <peak-size />
            </v-tab-item>
            <v-tab-item value="/admin/summary/impact">
                <impact />
            </v-tab-item>
            <v-tab-item value="/admin/summary/acceptance">
                <acceptance />
            </v-tab-item>
            <v-tab-item value="/admin/summary/awareness">
                <brand-awareness />
            </v-tab-item>
            <v-tab-item value="/admin/summary/loyalty">
                <loyalty />
            </v-tab-item>
            <v-tab-item value="/admin/summary/maxSales">
                <max-sales />
            </v-tab-item>
            <v-tab-item value="/admin/summary/monthSales">
                <month-sales />
            </v-tab-item>
            <v-tab-item value="/admin/summary/finishSales">
                <finish-sales />
            </v-tab-item>
            <v-tab-item value="/admin/summary/retailSales">
                <retail-sales />
            </v-tab-item>
            <v-tab-item value="/admin/summary/intermediary">
                <intermediary />
            </v-tab-item>
            <v-tab-item value="/admin/summary/finances">
                <finances />
            </v-tab-item>
        </v-tabs-items>
    </v-container>
</template>
<script>
import Franchise from './summary/Franchise.vue';
import PeakSize from './summary/PeakSize.vue';
import Impact from './summary/Impact.vue';
import Acceptance from './summary/Acceptance.vue';
import BrandAwareness from './summary/BrandAwareness.vue';
import Loyalty from './summary/Loyalty.vue';
import MaxSales from './summary/MaxSales.vue';
import MonthSales from './summary/MonthSales.vue';
import FinishSales from './summary/FinishSales.vue';
import RetailSales from './summary/RetailSales.vue';
import Intermediary from './summary/Intermediary.vue';
import Finances from './summary/Finances.vue';

export default {
    data() {
        return {
            itemsTab: [
                { title: 'Franchises', link: '/admin/summary/franchise' },
                { title: 'Segments actual peak size', link: '/admin/summary/peakSize' },
                { title: 'Impact of promotion', link: '/admin/summary/impact' },
                { title: 'Functional expansion acceptance', link: '/admin/summary/acceptance' },
                { title: 'Brand awareness', link: '/admin/summary/awareness' },
                { title: 'Brand loyalty', link: '/admin/summary/loyalty' },
                { title: 'Max sales', link: '/admin/summary/maxSales' },
                { title: 'Month sales', link: '/admin/summary/monthSales' },
                { title: 'Finish sales', link: '/admin/summary/finishSales' },
                { title: 'Retail sales', link: '/admin/summary/retailSales' },
                { title: 'Intermediary', link: '/admin/summary/intermediary' },
                { title: 'Finances', link: '/admin/summary/finances' },
                { title: 'Transition', link: '/admin/summary/transition' }
            ],
            tab: 0,
            valid: false,
            error: '',
            rules: {
                required: value => !!value || 'required field',
            },
            //props,
            game: null,
        }
    },
    computed: {
        games() {
            return this.$store.getters.games;
        },
        round() {
            if (this.game) {
                const game = this.games.find(g => g.id == this.game)
                return Number(game.round);
            }
            return 0;
        },
        financesRout() {
            return /\/summary\/finances/.test(this.$route.path);
        },
    },
    methods: {
        async load() {
            const obj = {
                gameId: this.game,
                round: this.round
            }
            //console.log(this.$route.path)
            try {
                if (this.$route.path === '/admin/summary/peakSize') {
                   await this.$store.dispatch('fetchMarketSegments', obj); 
                }
                else if (this.$route.path === '/admin/summary/impact') {
                    await this.$store.dispatch('fetchSpotsImpact', obj); 
                }
                else if (this.$route.path === '/admin/summary/acceptance') {
                    await this.$store.dispatch('fetchAdvancedFeatures', obj); 
                }
                else if (this.$route.path === '/admin/summary/awareness') {
                    await this.$store.dispatch('fetchAwareness', obj);
                }
                else if (this.$route.path === '/admin/summary/loyalty') {
                    await this.$store.dispatch('fetchLoyalty', obj);
                }
                else if (this.$route.path === '/admin/summary/retailSales') {
                    await this.$store.dispatch('fetchSales', obj);
                }
                else if (this.$route.path === '/admin/summary/finances') {
                    await this.$store.dispatch('fetchFinances', obj);
                }
                else if (this.$route.path === '/admin/summary/monthSales' 
                    || this.$route.path === '/admin/summary/maxSales'
                    || this.$route.path === '/admin/summary/finishSales') {
                    await this.$store.dispatch('fetchMonthsales', obj);
                }
                else if (this.$route.path === '/admin/summary/intermediary') {
                    await this.$store.dispatch('fetchIntermediary', obj);
                }
                else if (this.$route.path === '/admin/summary/franchise') {
                    await this.$store.dispatch('fetchChannels', obj);
                }
            }
            catch (err) {
                console.log(err)
            }
        },
        async calculate() {
            const obj = {
                gameId: this.game,
                round: this.round
            }
            try {
                switch(this.$route.path) {
                    case '/admin/summary/peakSize':
                        await this.$store.dispatch('calculateActualSize', obj);
                    break;
                    case '/admin/summary/impact':
                        await this.$store.dispatch('calculateSpotsImpact', obj);
                    break;
                    case '/admin/summary/acceptance':
                        await this.$store.dispatch('calculateAcceptance', obj);
                    break;
                    case '/admin/summary/awareness':
                        await this.$store.dispatch('calculateAwareness', obj);
                        break;
                    case '/admin/summary/loyalty':
                        await this.$store.dispatch('calculateLoyalty', obj);
                        break;
                    case  '/admin/summary/franchise' :
                       await this.$store.dispatch('calculateFranchiseNumber', obj);
                       await this.$store.dispatch('calculateIndependent', obj);
                    break;
                    case '/admin/summary/maxSales':
                        await this.$store.dispatch('calculateMonthSales', obj);
                    break;
                    case '/admin/summary/monthSales':
                        await this.$store.dispatch('calculateMonthSales', obj);
                    break;
                    case '/admin/summary/retailSales':
                        await this.$store.dispatch('calculateSales', obj);
                    break;
                    case '/admin/summary/intermediary':
                        await this.$store.dispatch('calculateIntermediary', obj);
                    break;
                    case '/admin/summary/finances':
                        await this.$store.dispatch('calculateFinances', obj);
                    break;
                }
            }
            catch (err) {
                console.log(err)
            }
        },
        async transitionNext() {
            const obj = {
                gameId: this.game,
                round: this.round
            }
            try {
                this.$store.dispatch('segmentTransition', obj);
                this.$store.dispatch('advancedFeatureTransition', obj);
                this.$store.dispatch('mediaTransition', obj); /* */
                this.$store.dispatch('productsTransition', obj);
                this.$store.dispatch('channelsTransition', obj);
                this.$store.dispatch('spotsTransition', obj);
                this.$store.dispatch('resourcesTransition', obj);
                this.$store.dispatch('financesTransition', obj);
                this.$store.dispatch('intermediaryTransition', obj); /* */
                this.$store.dispatch('updateGame', {id: this.game, round: parseInt(this.round) + 1})
            }
            catch(error) {
                console.log(error)
            }
        }
    },
    components: {
        Franchise, PeakSize, Acceptance, BrandAwareness, Loyalty, MonthSales,
        MaxSales, FinishSales, RetailSales, Finances, Impact, Intermediary
    },
    async mounted() {
        if (!this.games.length) {
            try {
               await this.$store.dispatch('fetchAllGames'); 
            }
            catch(error) {
                console.log(error.message)
            }
        }
    }
}
</script>